export default __webpack_public_path__ + "static/identity-mock-m11-4bda0fa4913694fda3e3dd3af9ded5d2.png";